"use client";

import { useEffect } from "react";

/**
 * Jauh di bawah TTL access token (15 menit) — heartbeat harus selalu sempat
 * merefresh sebelum access token benar-benar kedaluwarsa, bukan pas-pasan.
 */
const HEARTBEAT_INTERVAL_MS = 5 * 60 * 1000;

/**
 * Dipasang sekali di app/(app)/layout.tsx. Tidak merender apa pun — cuma
 * memicu POST /api/auth/heartbeat berkala (Route Handler, boleh menulis
 * cookie) supaya access token selalu segar TANPA bergantung pada Server
 * Component menemukannya basi saat render (lihat catatan di
 * app/api/auth/heartbeat/route.ts untuk kenapa ini perlu).
 *
 * Guest (tanpa sesi) aman dipasangi ini juga — heartbeat.route.ts no-op
 * kalau tidak ada accessToken/refreshToken di sesi.
 */
export function TokenHeartbeat() {
  useEffect(() => {
    let cancelled = false;

    function ping() {
      fetch("/api/auth/heartbeat", { method: "POST" }).catch(() => {
        // Kegagalan jaringan sesekali bukan masalah — percobaan berikutnya
        // (interval atau visibilitychange) akan mencoba lagi.
      });
    }

    // Segera saat mount — menutup celah "tab baru dibuka / kembali dari
    // background" tanpa menunggu interval pertama.
    ping();

    const id = setInterval(ping, HEARTBEAT_INTERVAL_MS);

    function onVisibilityChange() {
      if (!cancelled && document.visibilityState === "visible") ping();
    }
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      cancelled = true;
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, []);

  return null;
}
